import React from "react";
import "../CSS/styles.css";

const Case = () => {
  return (
    <div className="container mt-5 py-5 inter">
        <div className="row">
          <h1 className="text-center mb-0 bc fw-bold">Case Studies</h1>
          <p className="text-center mb-0 mt-3 gc2">Real-world examples of how we've helped organizations address their challenges.</p>
          <div className="col-lg-6 col-12 p-3 mt-lg-5 mt-3">
            <div className="wcc container-or-table3 int3 p-4 lb int2">
              <h5 className="mb-0 bc fw-semibold">Financial Institution Security Enhancement</h5>
              <p className="gc2 mb-0 mt-3">Helped a major bank strengthen its physical and digital security </p>
              <p className="mb-0 gc2">measures, reducing security incidents by 65%.</p>
            </div>
          </div>
           <div className="col-lg-6 col-12 p-3 mt-lg-5 mt-3">
            <div className="wcc container-or-table3 int3 p-4 lb int2">
              <h5 className="mb-0 bc fw-semibold">Manufacturing Risk Assessment</h5>
              <p className="gc2 mb-0 mt-3">Conducted comprehensive risk assessment for a global manufacturer,  </p>
              <p className="mb-0 gc2">identifying critical vulnerabilities and implementing mitigation strategies.</p>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Case
